import React from 'react';

export const Button = ({ readOnly, value, onClick }) => {

  const toggle = () => {
    onClick();
  };

  return (
    <div className="widget-button">
      <button
        disabled={readOnly}
        className='btn btn-sm mr-1 btn-light w-100'
        onClick={() => {
          readOnly || toggle();
        }}
        data-cy="button-widget"
      >
        {value}
      </button>
    </div>
  );
};
